export default "<h1>Component Demonstration</h1>\n<p>\n  This app will show how to use a couple of different components\n</p>\n"